import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiBell, FiSearch, FiDatabase, FiCloudLightning, FiActivity, FiLoader, FiLogOut } from 'react-icons/fi';

const Topbar = ({ toggleSidebar, backendStatus }) => {
  const handleLogout = () => {
    window.dispatchEvent(new CustomEvent('bpa-logout'));
  };

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sticky top-0 z-10">
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2 -ml-2 text-slate-500 hover:bg-slate-100 rounded-md"
        >
          <SafeIcon icon={FiMenu} className="text-xl" />
        </button>
        <div className="hidden sm:block">
          <h1 className="text-lg font-semibold text-slate-800 leading-tight">BPA Email Gateway</h1>
          <p className="text-xs text-slate-500">Central email routing, provider backup & delivery control</p>
        </div>
      </div>

      <div className="flex items-center gap-3 md:gap-4">
        {/* Dynamic Connection Status Badge */}
        {backendStatus === 'checking' && (
          <div className="px-2.5 py-1 text-[10px] font-bold bg-slate-100 text-slate-500 border border-slate-200 rounded-full flex items-center gap-1.5 shadow-sm">
            <SafeIcon icon={FiLoader} className="animate-spin text-slate-400" /> CONNECTING...
          </div>
        )}
        {backendStatus === 'live' && (
          <div className="px-2.5 py-1 text-[10px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-100 rounded-full flex items-center gap-1.5 shadow-sm animate-in fade-in zoom-in-95 duration-500">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            POCKETBASE LIVE
          </div>
        )}
        {backendStatus === 'mock' && (
          <div className="px-2.5 py-1 text-[10px] font-bold bg-amber-50 text-amber-800 border border-amber-100 rounded-full flex items-center gap-1.5 shadow-sm">
            <SafeIcon icon={FiCloudLightning} className="text-amber-500" /> MOCK MODE
          </div>
        )}

        <div className="h-8 w-px bg-slate-200 mx-1 hidden md:block"></div>

        <button 
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all text-xs font-bold group"
          title="Logout Admin Session"
        >
          <SafeIcon icon={FiLogOut} className="text-lg group-hover:rotate-12 transition-transform" />
          <span className="hidden lg:inline">Logout</span>
        </button>

        <div className="w-8 h-8 rounded-full bg-blue-100 border border-blue-200 flex items-center justify-center text-blue-700 font-semibold text-sm cursor-pointer hover:bg-blue-200 transition-colors">
          AD
        </div>
      </div>
    </header>
  );
};

export default Topbar;